// Module
var code = `<!--
    <div id="page-header">






    </div>-->
<div id="page-body">
  <div class="page-content page-tools-content"></div>
</div>
`;
// Exports
module.exports = code;